// Location: assets/gift-options.js
// What: Synchronizes conditional gift controls and cleans submitted line-item properties.
// Why: Keeps inactive noshi details and blank values out of fulfillment data.
// RELEVANT FILES: snippets/gift-options.liquid, assets/component-gift-options.css, tests/gift-options.test.mjs
if (!customElements.get('gift-options')) {
  customElements.define(
    'gift-options',
    class GiftOptions extends HTMLElement {
      constructor() {
        super();

        this.handleNoshiChange = this.syncNoshiDetails.bind(this);
        this.handleFormData = this.removeEmptyProperties.bind(this);
      }

      connectedCallback() {
        this.initialize();
        if (!this.isInitialized()) this.observeForInitialization();
      }

      disconnectedCallback() {
        this.initializationObserver?.disconnect();
        this.noshiSelect?.removeEventListener('change', this.handleNoshiChange);
        this.form?.removeEventListener('formdata', this.handleFormData);
        this.noshiSelect = null;
        this.noshiDetails = null;
        this.noshiControls = [];
        this.form = null;
      }

      initialize() {
        const noshiSelect = this.querySelector('[data-gift-options-noshi]');
        const noshiDetails = this.querySelector('[data-gift-options-noshi-details]');
        if (noshiSelect && noshiDetails) {
          if (this.noshiSelect !== noshiSelect) {
            this.noshiSelect?.removeEventListener('change', this.handleNoshiChange);
            this.noshiSelect = noshiSelect;
            this.noshiSelect.addEventListener('change', this.handleNoshiChange);
          }
          this.noshiDetails = noshiDetails;
          this.noshiControls = this.noshiDetails.querySelectorAll('input, select, textarea');
          this.syncNoshiDetails();
        }

        const form = document.getElementById(this.dataset.formId);
        if (this.form !== form) {
          this.form?.removeEventListener('formdata', this.handleFormData);
          this.form = form;
          this.form?.addEventListener('formdata', this.handleFormData);
        }

        if (this.isInitialized()) this.initializationObserver?.disconnect();
      }

      isInitialized() {
        const noshiReady = this.dataset.hasNoshi !== 'true' || (this.noshiSelect && this.noshiDetails);
        return Boolean(this.form && noshiReady);
      }

      observeForInitialization() {
        this.initializationObserver ??= new MutationObserver(() => this.initialize());
        this.initializationObserver.observe(this, { childList: true, subtree: true });
      }

      syncNoshiDetails() {
        const noshiDisabled = this.noshiSelect.value === '熨斗不要';
        this.noshiDetails.hidden = noshiDisabled;
        for (const control of this.noshiControls) control.disabled = noshiDisabled;
      }

      removeEmptyProperties(event) {
        for (const [key, value] of Array.from(event.formData.entries())) {
          if (key.startsWith('properties[') && typeof value === 'string' && value.trim() === '') {
            event.formData.delete(key);
          }
        }
      }
    }
  );
}
